export default {
  init() {

    setTimeout(function() {
        finalReportSingleImgPlace();
    }, 500);

  },
  finalize() {

    $(window).resize(function() {
        finalReportSingleImgPlace();
    });

  },
};

function finalReportSingleImgPlace() {
    if ( $('.js-final-report-single-img').length ) {
        var size = $('.js-final-report-single-img').height() / 3 * 2;
        $('.js-final-report-single-img').css('margin-bottom', '-' + size + 'px');
        $('.js-final-report-single-content').css('padding-top', size + 'px');
    }
}


// WEBPACK FOOTER //
// ./scripts/routes/single-final_report.js